import Amount from './Amount';
import Basic from './Basic';
import Calendar from './Calendar';
import Code from './Code';
import Password from './Password';
import Select from './Select';
import Textarea from './Textarea';
import WithButton from './WithButton';

export default {
  Basic,
  Calendar,
  Password,
  Code,
  Select,
  WithButton,
  Amount,
  Textarea
};
